<!--返回顶部组件-->
<template>
  <transition :name="transitionName">
    <div v-show="visible" :style="customStyle" class="back-to-ceiling" @click="backToTop">
      <span class="iconfont" style="font-size:22px;color:#aeaeae">&#xe633;</span>
    </div>
  </transition>
</template>

<script>
  export default {
    name: 'BackToTopComponent',
    props: {
      visibilityHeight: { type: Number,  default: 100 },
      backPosition: {     type: Number, default: 0   },
      transitionName: {  type: String, default: 'fade' },
      customStyle: {      type: Object,  default: function() {
          return {
            right: '20px',
            bottom: '20px',
            width: '40px',
            height: '40px',
            'border-radius': '4px',
            'line-height': '45px',
          //  background: '#e7eaf1'
          }
        }
      }
    },
    data() {
      return {
        visible: false,
        interval: null,
        isMoving: false
      }
    },
    mounted() {
      window.addEventListener('scroll', this.handleScroll)
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.handleScroll)
      if (this.interval) {
        clearInterval(this.interval)
      }
    },
    methods: {
      handleScroll() {
        this.visible = window.pageYOffset > this.visibilityHeight
      },
      backToTop() {
        if (this.isMoving) return
        const start = window.pageYOffset
        let i = 0
        this.isMoving = true
        this.interval = setInterval(() => {
          const next = Math.floor(this.easeInOutQuad(10 * i, start, -start, 500))
          if (next <= this.backPosition) {
            window.scrollTo(0, this.backPosition)
            clearInterval(this.interval)
            this.isMoving = false
          } else {
            window.scrollTo(0, next)
          }
          i++
        }, 16.7)
      },
      easeInOutQuad(t, b, c, d) {
        if ((t /= d / 2) < 1) return c / 2 * t * t + b
        return -c / 2 * (--t * (t - 2) - 1) + b
      }
    }
  }
</script>

<style scoped>
  .back-to-ceiling {
    position: fixed;
    display: inline-block;
    text-align: center;
    cursor: pointer;
  }

  .back-to-ceiling:hover {
    background: #d5dbe7;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity .5s;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0
  }

  .back-to-ceiling .Icon {
    fill: #f3f2f20e;
    background: none;
  }
</style>

